<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-solid fa-rocket" />&nbsp;{{ $t('campaigns') }}
        </template>
        <CampaignsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import CampaignsTable from '@partials/campaigns/CampaignsTable.vue'
</script>

<style lang="scss" scoped></style>
